<div class="flex flex-col flex-1 gap-y-2" *ngIf="displayType === 'list'">
  <span class="text-gray-900 font-bold">
    {{ title }}
  </span>
  <div class="flex flex-col gap-y-3">
    <div
      *ngFor="let fracActivity of fracActivityInfo | orderBy: 'asc':'completedPercentage'; trackBy: 'id' | trackByKey"
    >
      <ng-container *ngIf="fracStatus === 'running' || fracStatus === 'down'; else showEstablished">
        <div class="flex flex-row justify-between mb-1">
          <div class="text-gray-900 mb-1">
            <span>
              {{ fracActivity.name | uppercase }}
            </span>
            -
            <span class="font-bold" [ngClass]="fracStatus === 'running' ? ['text-green-100'] : ['text-red-400']">
              {{ fracActivity.completedPercentage }} %
            </span>
            Completed
          </div>
          <div>
            <a
              mat-button
              color="primary"
              target="_blank"
              href="https://maps.google.com/?q={{ fracActivity.lngLat[1] }},{{ fracActivity.lngLat[0] }}"
              >View On Map</a
            >
          </div>
        </div>
        <div class="w-full bg-gray-400 h-1">
          <div
            class="h-1"
            [ngClass]="fracStatus === 'running' ? ['bg-green-100'] : ['bg-red-100']"
            [ngStyle]="{ width: 'calc(' + fracActivity.completedPercentage + '%)' }"
          ></div>
        </div>
      </ng-container>
      <ng-template #showEstablished>
        <div class="text-gray-900 mb-1">
          <span>
            {{ fracActivity.name | uppercase }}
          </span>
          - Est. Start {{ fracActivity.established | date: 'shortDate' }}
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div class="flex" *ngIf="displayType === 'table'">
  <table mat-table [dataSource]="fracActivityInfo | orderBy: 'asc':'completedPercentage'" class="w-full" multiTemplateDataRows>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="w-4/12">Name</th>
      <td mat-cell *matCellDef="let element" class="w-4/12">
        <span class="align-middle" matTooltipClass="bg-red-200" [matTooltipPosition]="'above'" matTooltip='Reported Down at {{ element.reportedTimestamp | date: "medium" }} for {{ element.eta | minutesToHuman }}: "{{ element.downDescription }}" by {{ element.reportedUser }}' *ngIf="fracStatus === 'down'">
          <mat-icon class="text-red-200 cursor-pointer text-xl align-text-top">
            report
          </mat-icon>
        </span>
        <span class="font-bold">
          {{ element.name | uppercase }}
        </span>
          -
          <span class="font-bold" [ngClass]="fracStatus === 'running' ? ['text-green-100'] : ['text-red-400']">
          {{ element.completedPercentage }}%
        </span>
          Completed
      </td>
    </ng-container>
    <ng-container matColumnDef="progressBar">
      <th mat-header-cell *matHeaderCellDef class="w-3/12"></th>
      <td mat-cell *matCellDef="let element" class="w-3/12">
        <div class="rounded-md bg-gray-400 h-1 mx-2">
          <div
            class="h-1 rounded-md"
            [ngClass]="fracStatus === 'running' ? ['bg-green-100'] : ['bg-red-400']"
            [ngStyle]="{ width: 'calc(' + element.completedPercentage + '%)' }"
          ></div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="trailerType">
      <th mat-header-cell *matHeaderCellDef class="w-2/12">Trailer Type</th>
      <td mat-cell *matCellDef="let element" class="w-2/12"> {{ element.trailerTypeName | dashIfNothing }} </td>
    </ng-container>
    <ng-container matColumnDef="waitTime">
      <th mat-header-cell *matHeaderCellDef class="w-1/12">Wait Time</th>
      <td mat-cell *matCellDef="let element" class="w-1/12"> {{ element.waitTimeInMinutes ? (element.waitTimeInMinutes | prettyPrintMinutes) : 'N/A' }} </td>
    </ng-container>

    <ng-container matColumnDef="viewOnMap">
      <th mat-header-cell *matHeaderCellDef class="w-2/12"></th>
      <td mat-cell *matCellDef="let element" class="w-2/12">
        <a
          mat-button
          color="primary"
          target="_blank"
          href="https://maps.google.com/?q={{ element.lngLat[1] }},{{ element.lngLat[0] }}"
          >View On Map</a
        >
      </td>
    </ng-container>

    <!-- Secondary Column -->
<!--    <ng-container matColumnDef="secondary" *ngIf="fracStatus === 'down'">-->
<!--      <td mat-cell class="bg-red-200 text-gray-300 text-xs italic" [attr.colspan]="displayedColumns.length" *matCellDef="let element">-->
<!--        *** Reported Down at {{ element.reportedTimestamp | date: 'medium' }} for {{ element.eta | minutesToHuman }}: "{{ element.downDescription }}" by {{ element.reportedUser }}-->
<!--      </td>-->
<!--    </ng-container>-->

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
<!--    <ng-container *ngIf="fracStatus === 'down'">-->
<!--      <tr mat-row *matRowDef="let row; columns: ['secondary'];"></tr>-->
<!--    </ng-container>-->

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-gray-600 italic" colspan="6">No Fracs</td>
    </tr>
  </table>
</div>
